<section class="client-form-page">
  <header class="form-header">
    <a class="back-link" routerLink="/dashboard/clients">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>
      <span>К списку клиентов</span>
    </a>
    <h1>{{ title }}</h1>
  </header>

  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <form class="client-form" (ngSubmit)="saveClient()" *ngIf="!loading; else loadingState">
    <div class="form-main">
      <section class="form-card">
        <div class="panel-heading">
          <h2>Основные данные</h2>
        </div>

        <div class="form-grid">
          <label>
            <span>Имя</span>
            <input class="form-control" name="firstName" placeholder="Ира" [(ngModel)]="formData.firstName" required>
          </label>

          <label>
            <span>Фамилия</span>
            <input class="form-control" name="lastName" placeholder="Иванова" [(ngModel)]="formData.lastName">
          </label>

          <label>
            <span>Телефон</span>
            <input class="form-control" name="phone" placeholder="+7 (900) 111-22-33" [ngModel]="formatPhone(formData.phone)" (ngModelChange)="updatePhone($event)">
          </label>

          <label>
            <span>Скидка, %</span>
            <input class="form-control" type="number" min="0" max="100" step="1" name="personalDiscountPercent" placeholder="15" [(ngModel)]="formData.personalDiscountPercent">
          </label>

          <label class="wide">
            <span>Источник</span>
            <select class="form-select" name="acquisitionSourceId" [(ngModel)]="formData.acquisitionSourceId">
              <option [ngValue]="null">Не указан</option>
              <option *ngFor="let source of sources; trackBy: trackById" [ngValue]="source.id">{{ source.name }}</option>
            </select>
          </label>
        </div>
      </section>

      <section class="form-card">
        <div class="panel-heading">
          <h2>Связь</h2>
        </div>

        <div class="form-grid">
          <label>
            <span>Telegram ID</span>
            <input class="form-control" inputmode="numeric" name="telegramId" placeholder="1 180 898 942" [ngModel]="formatGroupedNumber(formData.telegramId)" (ngModelChange)="updateTelegramId($event)">
          </label>

          <label>
            <span>Telegram username</span>
            <input class="form-control" name="telegramUsername" placeholder="@anna7778988" [ngModel]="formData.telegramUsername" (ngModelChange)="updateTelegramUsername($event)">
          </label>

          <label>
            <span>MAX ID</span>
            <input class="form-control" inputmode="numeric" name="maxId" placeholder="1 180 898 942" [ngModel]="formatGroupedNumber(formData.maxId)" (ngModelChange)="updateMaxId($event)">
          </label>

          <label>
            <span>Почта</span>
            <input class="form-control" type="email" name="email" placeholder="client@example.ru" [(ngModel)]="formData.email">
          </label>

          <label class="wide">
            <span>Авито</span>
            <input class="form-control" type="url" name="avitoProfileUrl" placeholder="https://www.avito.ru/user/..." [(ngModel)]="formData.avitoProfileUrl">
          </label>
        </div>
      </section>
    </div>

    <aside class="side-column">
      <section class="form-card">
        <div class="panel-heading">
          <h2>Статус и настройки</h2>
        </div>

        <div class="settings-stack">
          <label>
            <span>Подписка</span>
            <div class="teams-select" *ngIf="teams.length > 0; else emptyTeams">
              <button class="teams-select-trigger" type="button" [attr.aria-expanded]="teamsMenuOpen" aria-haspopup="listbox" (click)="toggleTeamsMenu()">
                <span>{{ selectedTeamsText }}</span>
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>
              </button>

              <div class="teams-options" role="listbox" aria-multiselectable="true" *ngIf="teamsMenuOpen">
                <label class="team-option" *ngFor="let team of sortedTeams; trackBy: trackById">
                  <input type="checkbox" [checked]="isTeamSelected(team.id)" (change)="toggleTeam(team.id)">
                  <span>{{ team.name }}</span>
                  <small>{{ team.championship }}</small>
                </label>
              </div>
            </div>

            <ng-template #emptyTeams>
              <p class="empty-note">Команды пока не добавлены.</p>
            </ng-template>
          </label>

          <label>
            <span>Ответственный</span>
            <select class="form-select" name="ownerUserId" [(ngModel)]="formData.ownerUserId" required>
              <option [ngValue]="null">Выберите пользователя</option>
              <option *ngFor="let user of users; trackBy: trackById" [ngValue]="user.id">{{ user.displayName || user.username }}</option>
            </select>
          </label>

          <label class="status-toggle-row">
            <span>Статус</span>
            <button class="status-toggle" type="button" [class.active]="formData.status === 'active'" (click)="formData.status = formData.status === 'active' ? 'inactive' : 'active'">
              <span class="toggle-control"></span>
              <strong>{{ formData.status === 'active' ? 'Активен' : 'Не активен' }}</strong>
            </button>
          </label>
        </div>
      </section>

      <section class="form-card actions-card">
        <button class="save-button" type="submit" [disabled]="saving || formInvalid">{{ saving ? 'Сохраняем...' : 'Сохранить' }}</button>
        <a class="ghost-link" routerLink="/dashboard/clients">Отмена</a>
        <button class="delete-button" type="button" *ngIf="mode === 'edit'" (click)="deleteClient()">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/></svg>
          <span>Удалить клиента</span>
        </button>
      </section>
    </aside>
  </form>

  <ng-template #loadingState>
    <div class="form-card loading-card">Загрузка данных...</div>
  </ng-template>
</section>
